module.exports = __webpack_public_path__ + "static/media/btn_02.f5312650.png";